import {Component, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'mydocma-dynamic-form-base-value-accessor-field',
    templateUrl: './base-value-accessor-field.component.html',
    styleUrls: ['./base-value-accessor-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BaseValueAccessorFieldComponent),
            multi: true
        }
    ]
})
export class BaseValueAccessorFieldComponent implements ControlValueAccessor {

    registerOnChange(fn: any): void {
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(input: string) {
    }
}
